<template>
  <div class="direct-debit">
    <div class="card-header bg-default">
      <strong>Account: </strong>
      <router-link :to="'/membership/members/' + directDebit.Account.uuid">
        {{ directDebit.Account.dropdownLabel }}
      </router-link>
    </div>
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <strong>Amount: </strong>
        {{ directDebit.cost | to_dollar_amount }}
      </div>
      <div class="list-group-item">
        <strong>Period: </strong>
        {{ directDebit.startDate | short_date_format }} - {{ directDebit.endDate | short_date_format }}
      </div>
    </div>
    <div class="alert alert-info" v-if="!completed">
      <div class="row">
        <div class="col-6" v-if="directDebit.lastPaid">
          <strong>Last Paid:</strong><br/>
          <span class="fa fa-calendar-alt"></span> {{ directDebit.lastPaid | short_date_format }}
        </div>
        <div class="col-6">
          <strong>Next Payment Scheduled:</strong><br/>
          <span class="fa fa-calendar-alt"></span> {{ nextPayment | short_date_format }}
        </div>
      </div>
    </div>
    <div v-else class="alert alert-success">
      <h5>Direct Debit term completed.</h5>
      <p>
        <strong>Last Payment Received:</strong><br/>
        <span class="fa fa-calendar-alt"></span> {{ directDebit.lastPaid | short_date_format }}
      </p>
    </div>
    <div class="card-footer clearfix">
      <router-link class="btn btn-primary btn-sm float-right" :to="'/membership/direct-debit/edit/' + directDebit.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DirectDebit',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    directDebit () {
      return {
        ...this.object
      }
    },
    nextPayment () {
      if (this.directDebit.lastPaid) {
        return moment(this.directDebit.lastPaid).add(1, 'month')
      } else {
        return moment(this.directDebit.startDate)
      }
    },
    completed () {
      return moment(this.directDebit.endDate).subtract(1, 'month').isBefore(moment())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/DirectDebit.vue